import { finish, error } from '../../../modules/events/actions/search';
import api from '../../../api';

export function request(dispatch, { query }) {
    api.get('/events/search', query).then(
        (result) => {
            let { events } = result;
            dispatch(finish(events));
        },
        ({ errors }) => dispatch(error(errors))
    );
}
